import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useSearchAutoComplete } from '@/composables/useSearchAutoComplete';
import { Tag } from '@/models/tag';
import gql from 'graphql-tag';
import { AutoCompleteItemSelectEvent, AutoCompleteItemUnselectEvent } from 'primevue/autocomplete';
import { ref, toRef } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    tags: null
  },
  emits: ["update"],
  setup(__props: any, { emit }) {

const props = __props as {
  tags?: Tag[]
}

const { onResult, suggestions, onComplete, lastSearchedText } = useSearchAutoComplete(gql`
   query SearchTags($search: String!) {
    search_tags(args: {search: $search}) {
      name
      post_tags_aggregate {
        aggregate {
          count
        }
      }
    }
  }`
)





const selectedTags = ref(toRef(props, "tags").value);

let filteredTags = selectedTags.value?.map(tag => tag.name);

onResult(({ data: { search_tags } }) => {
    suggestions.value = search_tags

    if (!suggestions.value.find((tag: Tag) => tag.name === lastSearchedText.value)) {
        suggestions.value = [
            {
                name: lastSearchedText.value,
                post_tags_aggregate: {
                    aggregate: {
                        count: "new tag"
                    }
                }
            },
            ...suggestions.value,
        ]
    }
})

const onItemSelect = (event: AutoCompleteItemSelectEvent) => {
    const { name } = event.value;
    if (selectedTags.value!.length > 5)
        return selectedTags.value!.pop()
    filteredTags?.push(name)
    emit("update", filteredTags)
}

const onItemUnselect = (event: AutoCompleteItemUnselectEvent) => {
    const { name } = event.value;
    filteredTags = filteredTags?.filter(tag => tag !== name);
    emit("update", filteredTags)
}

return (_ctx: any,_cache: any) => {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createBlock(_component_AutoComplete, {
    multiple: true,
    modelValue: selectedTags.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTags).value = $event)),
    suggestions: _unref(suggestions),
    onComplete: _cache[1] || (_cache[1] = ($event: any) => (_unref(onComplete)($event))),
    field: "name",
    onItemSelect: _cache[2] || (_cache[2] = ($event: any) => (onItemSelect($event))),
    onItemUnselect: _cache[3] || (_cache[3] = ($event: any) => (onItemUnselect($event))),
    inputClass: "w-full",
    class: "w-full autocomplete"
  }, {
    item: _withCtx((slotProps) => [
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(slotProps.item.name) + " ", 1),
        _createElementVNode("small", null, "(" + _toDisplayString(slotProps.item.post_tags_aggregate.aggregate.count) + ")", 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "suggestions"]))
}
}

})